module.exports = __webpack_public_path__ + "static/img/AccountSupport_img4.51885a95.png";